import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AppAnimations } from 'src/app/_shared/animations';
import { DropDown } from 'src/app/_shared/interfaces/dropdown.interface';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';


import { DataSharingService, UtilsService } from 'src/app/_core/services';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';
import { ValidatorService } from 'src/app/_shared/validators/validator.service';
import { PUT_PrepaidRule } from 'src/app/_shared/models/rules.model';
import { collectionOfChargePrepaidRulesAction, collectionOfChargePrepaidRulesAmountTypes, VisibleState, SubscriptionRuleTypes, ChargePrepaidRulesCountType, SubscriptionRuleStatus, collectionOfChargesPrepaidRulesEvents, ChargePrepaidRulesEvents, ChargeRulesPrepaidAction, ChargePrepaidRulesAmountTypes, ChargeType } from 'src/app/app.data';

@Component({
  animations: [AppAnimations],
  selector: 'app-charge-prepaid-rules',
  templateUrl: './charge-prepaid-rules.component.html',
})
export class ChargePrepaidRulesComponent implements OnInit, OnDestroy {

  checkedPrepaidRuleSubscription: boolean = false;
  cleaveNumDecimalOptions: any;
  cleaveNumIntegerOptions: any;
  collectionOfPrepaidRulesAction: Array<DropDown> = collectionOfChargePrepaidRulesAction;
  collectionOfPrepaidRulesAmountTypes: Array<DropDown> = collectionOfChargePrepaidRulesAmountTypes;
  collectionOfPrepaidRulesEvents: Array<DropDown> = collectionOfChargesPrepaidRulesEvents;
  form: FormGroup;
  model: any;

  @Input() _chargeType = ChargeType;
  @Input() _data: any;
  @Input() _selectedChargeType: ChargeType = ChargeType.oneTimeCharge;
  @Input() _visibleState = VisibleState;

  @Output() _emitPrepaidErrors: EventEmitter<any> = new EventEmitter<any>();
  @Output() _emitPrepaidRules: EventEmitter<any> = new EventEmitter<any>();

  private subs = new Unsubscriber();

  constructor(
    private _fb: FormBuilder,
    private _shareData: DataSharingService,
    private _validatorService: ValidatorService,
    private utils: UtilsService
  ) {
    this.subs.addSub = this._shareData.getSettingsVariables().subscribe(([decimalPlaces, decimalToken, thousandsToken]) => {
      this.cleaveNumDecimalOptions = {
        numeral: true,
        numeralPositiveOnly: true,
        stripLeadingZeroes: false,
        numeralDecimalScale: decimalPlaces,
        delimiter: thousandsToken,
        numeralDecimalMark: decimalToken
      };
      this.cleaveNumIntegerOptions = {
        numeral: true,
        numeralPositiveOnly: true,
        stripLeadingZeroes: false,
        numeralDecimalScale: 0,
        delimiter: thousandsToken,
        numeralDecimalMark: decimalToken
      };
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this.setUpForm();
  }

  onChangePrepaidRuleSubscription($event) {
    if($event.checked) {
      this.form.get('prepaidRulesAmount').setValidators([Validators.required, this._validatorService.positiveDecimalNumberIncludeZero]);
      this.form.get('prepaidRulesAmount').updateValueAndValidity();
      this.form.get('prepaidCount').setValidators([Validators.required, this._validatorService.positiveDecimalNumberExcludeZero, Validators.max(999)]);
      this.form.get('prepaidCount').updateValueAndValidity();
    } else {
      this.form.get('prepaidRulesAmount').setValidators([]);
      this.form.get('prepaidRulesAmount').updateValueAndValidity();
      this.form.get('prepaidCount').setValidators([]);
      this.form.get('prepaidCount').updateValueAndValidity();
    }
  }

  setUpForm() {
    this.model = this._data?.ratePlanCharge?.rules?.find(x => x.ruleType == SubscriptionRuleTypes.prepaidRule);
    let cantRows = this._data?.ratePlanCharge?.rules?.length;

    if( cantRows > 0 && this.model) {
      this.checkedPrepaidRuleSubscription = true;
    } else {
      this.checkedPrepaidRuleSubscription = false;
    }

    this.form = this._fb.group({
      prepaidAction: [this.model?.action ? this.model.action : ChargeRulesPrepaidAction.add],
      prepaidCountType: [this.model?.countType ? this.model.countType : ChargePrepaidRulesCountType.every],
      prepaidCount: [this.model?.count ? this.model.count : 1],
      prepaidEvent: [this.model?.event ? this.model.event : ChargePrepaidRulesEvents.invoicePosted],
      prepaidRulesAmount: [this.model?.amount ? this.model.amount : this.utils.formatDecimalNumberToReceive(1)],
      prepaidRulesAmountType: [this.model?.amountType ? this.model.amountType : ChargePrepaidRulesAmountTypes.price],
      prepaidRulesEnabled: [this.checkedPrepaidRuleSubscription]
    });

    if (this._data.inlineEdit) {
      this.form.get('prepaidRulesAmount').setValue(this.utils.formatDecimalNumberToReceive(this.form.get('prepaidRulesAmount').value));
    }

    if(this.checkedPrepaidRuleSubscription){
      this.form.get('prepaidRulesAmount').setValidators([Validators.required, this._validatorService.positiveDecimalNumberIncludeZero]);
      this.form.get('prepaidRulesAmount').updateValueAndValidity();
      this.form.get('prepaidCount').setValidators([Validators.required, this._validatorService.positiveDecimalNumberExcludeZero, Validators.max(999)]);
      this.form.get('prepaidCount').updateValueAndValidity();
    }
  }

  setBodyParams() {
    if(this.form.get('prepaidRulesEnabled').value){
      if (this.form.invalid) {
        this.form.markAllAsTouched();
        this.form.markAsDirty();
        this._emitPrepaidErrors.emit(true);
        return;
      }
      let bodyParams: PUT_PrepaidRule = {
        action: this.form.get('prepaidAction').value,
        amount:  this.utils.convertToNumber(this.form.get('prepaidRulesAmount').value),
        amountType: this.form.get('prepaidRulesAmountType').value,
        count: this.utils.convertToNumber(this.form.get('prepaidCount').value),
        countType: this.form.get('prepaidCountType').value,
        event: this.form.get('prepaidEvent').value,
        ruleType: SubscriptionRuleTypes.prepaidRule,
        status: SubscriptionRuleStatus.active
      };
      this._emitPrepaidRules.emit([bodyParams]);
    } else {
      this._emitPrepaidRules.emit([]);
    }
  }
}
